<template>
  <SelectSingleInput
    v-model="model"
    :items="items"
    item-text="lotNo"
    item-value="lotNo"
    :label="label"
    :disabled="disabled"
    :loading="loading"
    :required="required"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'MmmmLotInput',

  mixins: [APIUtils, Message],

  components: { SelectSingleInput },

  props: {
    value: {
      type: String,
      required: true,
    },
    inspTimingCd: {
      type: String,
      required: true,
    },
    manufacturerCd: {
      type: String,
      required: true,
    },
    partCd: {
      type: String,
      required: true,
    },
    inspStatusCd: {
      type: String,
      required: false,
      default: '',
    },
    isMmmmUnapproved: {
      type: Boolean,
      default: false,
      required: false,
    },
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0049')
      },
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
  },

  watch: {
    value: {
      handler(changedValue) {
        this.onChange(changedValue)
      },
    },
    async partCd(value) {
      await this.setLots(this.manufacturerCd, value)
    },
  },

  methods: {
    onChange(value) {
      this.$emit('change', value)
    },

    async setLots(manufacturerCd, partCd) {
      this.loading = true
      this.items = []

      try {
        if (manufacturerCd && partCd) {
          let params = {
            inspTimingCd: this.inspTimingCd,
            manufacturerCd: manufacturerCd,
            partCd: partCd,
            inspStatusCd: this.inspStatusCd,
            isMmmmUnapproved: this.isMmmmUnapproved,
          }

          const elements = await API.get('/inspIndex/inspIndexes/mmmm', params)
          this.items = elements.filter(
            (element, index, self) => self.findIndex((e) => e.lotNo === element.lotNo) === index,
          )
        }
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0049') })))
      } finally {
        this.loading = false
      }
    },
  },

  async mounted() {
    await this.setLots(this.manufacturerCd, this.partCd)
  },
}
</script>
